// extracted by mini-css-extract-plugin
export default {"wrapper":"DateHeader__wrapper--1vn-u","header":"DateHeader__header--20Alm","today":"DateHeader__today--1klJ4"};